import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import ResizeObserver from 'rc-resize-observer';

import 'ol/ol.css';
import Map from 'ol/Map';

export interface Props {
    map: Map | undefined,
    mapId?: string,
    children?: ReactNode[] | ReactNode;
}

/**
 * Renders a container for an openlayers map. 
 * Map automatically refreshes when size of its container is changed.
 * @param param0
 */
const ResponsiveMap: React.FC<Props> = ({
    map,
    mapId = `map-${Math.round(1e10 * Math.random())}`,
    children
}) => {

    const mapElement = useRef<HTMLDivElement>(null);
    const mapObject = useRef<Map>();
    const resizerTimeout = useRef<number>(-1);

    useEffect(() => {
        disposeMap(mapObject.current);
        mapObject.current = map;

        if (map) {
            map.setTarget(mapElement.current!);
            return () => {
                disposeMap(map);
                mapObject.current = undefined;
                window.clearTimeout(resizerTimeout.current)
            }
        }

    }, [map]);

    return (
        <ResizeObserver
            onResize={() => {
                window.clearTimeout(resizerTimeout.current)
                resizerTimeout.current = window.setTimeout(() => {
                    map?.updateSize();
                }, 50)
            }}>
            <div style={{
                width: "100%",
                height: "100%",
                position: "relative",
                background: "rgb(69, 110, 119)"
            }}>
                <div id={mapId}
                    ref={mapElement}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgb(255, 255, 255)",
                        overflow: "hidden"
                    }} />
                {children}
            </div>
        </ResizeObserver>
    )
}

export default observer(ResponsiveMap);

const disposeMap = (map?: Map) => {
    if (map) {
        map.setTarget(undefined);
        map.dispose();
    }
}